document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[js-main-products-media-swiper]')) return;

  const mainProductThumbSwiper = new Swiper("[js-main-products-media-thumbnails-swiper]", {
    spaceBetween: 15,
    slidesPerView: 4.5,
    allowTouchMove: true,
    centeredSlidesBounds: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      360: { spaceBetween: 10 },
      960: { spaceBetween: 15 },
    }
  });

  const mainProductSwiper = new Swiper('[js-main-products-media-swiper]', {
    allowTouchMove: false,
    slidesPerView: 1,
    effect: 'fade',
    // autoHeight removed: the main image now has a fixed aspect-ratio (CSS), so
    // the area no longer resizes between slides and the thumbnail strip below
    // it stops jittering up/down when navigating.
    navigation: {
      nextEl: ".swiper-button-next__container",
      prevEl: ".swiper-button-prev__container",
    },
    thumbs: {
      swiper: mainProductThumbSwiper,
      autoScrollOffset: 1,
    },
  });

  // The `thumbs` module already keeps the strip in sync with the main slider.
  // A second `controller.control` link fought that logic and made the movement
  // jerky, so it is intentionally not set.

  window.productGallerySlider = mainProductSwiper;
})
